import { useSearchParams } from 'react-router-dom';

import { DEFAULT_PAGE_LIMIT, DEFAULT_PAGE_NUMBER } from '@/constants';

export const useUrlPagination = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = Number(searchParams.get('page')) || DEFAULT_PAGE_NUMBER;
  const limit = Number(searchParams.get('limit')) || DEFAULT_PAGE_LIMIT;

  const setCurrentPage = (page: number) => {
    searchParams.set('page', page.toString());
    setSearchParams(searchParams);
  };

  const setPageLimit = (limit: number) => {
    searchParams.set('limit', limit.toString());
    setSearchParams(searchParams);
  };

  return { page, limit, setCurrentPage, setPageLimit };
};
